import request from '@/utils/request'

// 查询邮寄申请分页
export function pageMailApply(data) {
  return request({
    url: '/cloudplant/mailapply/page',
    method: 'post',
    data: data
  })
}

// 查询邮寄申请详情
export function getMailApply(data) {
  return request({
    url: '/cloudplant/mailapply/detail',
    method: 'get',
    params: data
  })
}

// 审核邮寄申请
export function auditMailApply(data) {
  return request({
    url: '/cloudplant/mailapply/audit',
    method: 'post',
    data: data
  })
}
